<mat-card class="container-card">
  <mat-card-content>
    <mat-tab-group #tabGroup mat-align-tabs="center" (selectedTabChange)="onJobTabChange($event)">
      <mat-tab label="{{ title('Scheduler Jobs') }}">
        <LOSx-manage-scheduler-jobs></LOSx-manage-scheduler-jobs>
      </mat-tab>
      <mat-tab label="{{ title('Workflow Jobs') }}">
        <LOSx-workflow-jobs></LOSx-workflow-jobs>
      </mat-tab>
      <mat-tab label="{{ title('COB') }}">
        <LOSx-cob-workflow [isCatchUpRunning]="isCatchUpRunning"></LOSx-cob-workflow>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
